import React from "react";
import { useNavigate } from "react-router-dom";

import { format, parse } from "date-fns";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Box, Grid, Typography } from "@mui/material";
import StatusSymbol from "./StatusSymbol";
import { NumberFormatUtils } from "../../../utility/NumberFormatUtils";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

const OrderCard = (props) => {
  const navigate = useNavigate();
  const order = props.order;
  const warehouseId = props.warehouseId;
  return (
    <Grid item xs={12} md={4} sm={6} lg={4}>
      <Card
        key={order.id}
        onClick={() => {
          navigate(`/${order.order_Id}`, {
            state: { warehouseId: warehouseId },
          });
        }}
        variant="outlined"
        sx={{
          borderRadius: 2,
          boxShadow: 2,
          display: "flex",
          justifyContent: "space-between",
          margin: 0.5,
          textDecoration: "none",
          marginX: 1,
        }}
      >
        <CardContent
          style={{
            // justifyContent: "flex-start",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h2"
            gutterBottom
            style={{
              textDecoration: "none",
              justifyContent: "flex-start",
              display: "flex",
            }}
          >
            Order ID: {order.order_Id}
          </Typography>
          <Typography
            variant="subtitle1"
            color="primary"
            sx={{ textDecoration: "none" }}
          >
            {format(
              parse(order.order_fordate, "dd-MM-yyyy HH:mm:ss", new Date()),
              "dd MMM yyyy, h:mm a"
            )}
          </Typography>
        </CardContent>
        <CardContent>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
          >
            <Typography variant="h3">
              <CurrencyRupeeIcon sx={{ fontSize: "medium" }} />
              {NumberFormatUtils(order.order_amount)}
            </Typography>
          </Box>

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
          >
            <StatusSymbol stateName={order.orderstate_nameAliase} />
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default OrderCard;
